import { loginService } from '@services/auth';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useUserAnalytics } from '../hooks/useUserAnalytics';
import { AUTH_EVENTS } from '../utils/eventSchema';

export const useLogin = () => {
  const { trackEvent } = useUserAnalytics();
  return useMutation({
    mutationFn: loginService,
    onSuccess: (response) => {
      // Save token to localStorage
      if (response?.access_token) {
        localStorage.setItem('jwtToken', response.access_token);

        // Identify user for analytics
        identifyUserWithProfile(response.user);

        // Track login success
        trackEvent('auth', {
          ...AUTH_EVENTS.LOGIN_SUCCESSFUL,
          login_time: new Date().toISOString(),
          login_method: 'password',
          device: navigator.userAgent,
        });
      }
    },
    onError: (error) => {
      console.error('Login failed:', error);
      toast.error(error.response?.data?.detail || 'Unable to login', {
        autoClose: 3000,
      });
    },
  });
};

const identifyUserWithProfile = (user) => {
  if (window.analytics && user) {
    const { id, email, first_name, last_name } = user;
    window.analytics.identify(id, {
      email,
      firstName: first_name,
      lastName: last_name,
      name: `${first_name} ${last_name}`,
    });
  }
};
